export const mobileImage =
  'https://assets.riparide.com/home/voucher_info/inline-banner-mobile.jpg'

export const desktopImage =
  'https://assets.riparide.com/home/voucher_info/inline-banner.jpg'
